import React, {useState, useEffect} from "react";
import "./index.css";
import cn from "classnames";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import ImageUpload from "../../../layout/ImageUpload/index";
import {newsletterLayoutTypes, UI} from "../../../data/constants";
import {WITHOUT_LOGOS_SET} from "data/products/index";
import {checkIfIDE} from "../../../data/products/index";
import {checkProductInText} from "../../../libs/utils";
import Icon from "../../../layout/Icon";
import BgTransformer from "../../../layout/BgTransformer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {resolveProductAccentColor} from "../../../utils/colors";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import {palettes} from "../../../data/palettes";

const YouTubeThumbnail = ({id, zoom}) => {
  const {product, layoutOption, iconOption, type, channel, isUppercase} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, subtitles, dates, productNames} = useEdits();
  const [showProductName, setShowProductName] = useState(true);
  const logoURL = useLogoUrl(id);
  const title = titles[id] || titles.main;
  const date = dates[id] || dates.main;
  const subtitle = subtitles[id] || subtitles.main;
  const productName = productNames[id] || productNames.main || product.altLabel || product.label;
  const iconUrl = `${UI}/Icons/${iconOption}.svg`;
  const isNewsletter = newsletterLayoutTypes.includes(type.value);
  const newsletterClass = isNewsletter ? "newsletter" : "";
  const templateClass = cn("template", `layout-${layoutOption}`, newsletterClass);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value, type.value)});
  const col = resolveProductAccentColor(product.value, palettes);
  const isEmptyLogo = WITHOUT_LOGOS_SET.has(product.value);
  const backgroundBlurOverride = +layoutOption === 4 ? 10 : undefined;
  // Check if product name is in the text
  useEffect(() => {
    if (product && product.label) {
      const isProductInText = checkProductInText(product.label, title);
      setShowProductName(!isProductInText);
    }
  }, [product, title]);

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} blurOverride={backgroundBlurOverride} />

          <div className="content">
            <header className="template-header">
              {!isUppercase && (
                <div className="product-name">
                  <ContentEditable id={id} text={productName} />
                </div>
              )}
              <div className={logoClass}>
                <img src={logoURL} alt="background" />
              </div>
            </header>

            <div className="title-wrap">
              <h1 className="title">
                <ContentEditable id={id} text={title} color={col ?? "#FCF84A"} />
              </h1>
            </div>
          </div>

          {[2, 3].includes(+layoutOption) && (
            <div className="upload-wrap">
              <ImageUpload
                id={id}
                isLogo={+layoutOption === 3}
                key={`upload-${+layoutOption}-${id}`}
                emptyLogo={isEmptyLogo}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default YouTubeThumbnail;
